import { AssetCategory, AssetType, IPNLSubTabs, } from "@domains/aggregates/interfaces/Reports/iPNLReport";
import { assetWiseProducts } from "@domains/mapper/Reports/AssetsAndProducts";
export var FilterTabEnum;
(function (FilterTabEnum) {
    FilterTabEnum["ALL"] = "all";
    FilterTabEnum["EQUITY"] = "Equity";
    FilterTabEnum["FI"] = "Fixed Income";
    FilterTabEnum["DERIVATIVE"] = "Derivative";
    FilterTabEnum["MP"] = "Managed Portfolio";
    FilterTabEnum["INSURANCE"] = "INSURANCE";
    FilterTabEnum["OTHERS"] = "Other";
})(FilterTabEnum || (FilterTabEnum = {}));
export var EReportsQParamKey;
(function (EReportsQParamKey) {
    EReportsQParamKey["TAB"] = "tab";
    EReportsQParamKey["REPORT_NAME"] = "reportName";
})(EReportsQParamKey || (EReportsQParamKey = {}));
export var EOtherReportTabs;
(function (EOtherReportTabs) {
    EOtherReportTabs["DP_BILL"] = "dpbills";
    EOtherReportTabs["CONTRACT_NOTES"] = "contract-notes";
    EOtherReportTabs["SUBSCRIPTION_HISTORY"] = "subscription-history";
    EOtherReportTabs["DELAYED_PAYMENT_INTEREST"] = "delayed-payment-interest";
    EOtherReportTabs["LEDGER_REPORT"] = "ledger-report";
})(EOtherReportTabs || (EOtherReportTabs = {}));
export const OtherReport = {
    [EOtherReportTabs.DP_BILL]: "DP Bills",
    [EOtherReportTabs.CONTRACT_NOTES]: "Contract Notes and Statements",
    [EOtherReportTabs.DELAYED_PAYMENT_INTEREST]: "Delayed Payment Interest",
    [EOtherReportTabs.SUBSCRIPTION_HISTORY]: "Subscription history",
    [EOtherReportTabs.LEDGER_REPORT]: "Ledger Report",
};
export const reportsTabAndDropDownData = {
    [FilterTabEnum.ALL]: {
        assetName: "All",
        assetProductList: [],
        showList: false,
    },
    [FilterTabEnum.EQUITY]: {
        assetName: FilterTabEnum.EQUITY,
        showList: true,
        assetProductList: [
            { display: "All", value: AssetType.EQ },
            ...assetWiseProducts.get(AssetCategory.Equity),
        ],
    },
    [FilterTabEnum.FI]: {
        assetName: FilterTabEnum.FI,
        showList: true,
        assetProductList: [
            { display: "All", value: AssetType.FixedIncome },
            ...assetWiseProducts.get(AssetCategory.FixedIncome),
        ],
    },
    [FilterTabEnum.DERIVATIVE]: {
        assetName: FilterTabEnum.DERIVATIVE,
        showList: true,
        assetProductList: [
            { display: "All", value: AssetType.Derivatives },
            ...assetWiseProducts.get(AssetCategory.Derivatives),
        ],
    },
    [FilterTabEnum.MP]: {
        assetName: FilterTabEnum.MP,
        showList: true,
        assetProductList: [
            { display: "All", value: AssetType.MP },
            ...assetWiseProducts.get(AssetCategory.ManagedPortfolio),
        ],
    },
    [FilterTabEnum.OTHERS]: {
        assetName: FilterTabEnum.OTHERS,
        showList: true,
        assetProductList: [
            { display: "All", value: [AssetType.RealEstate, AssetType.Commodity] },
            ...assetWiseProducts.get(AssetCategory.Others),
        ],
    },
    [FilterTabEnum.INSURANCE]: {
        assetName: FilterTabEnum.INSURANCE,
        assetProductList: [
            { display: "All", value: AssetType.LIFE_INSURANCE },
            ...assetWiseProducts.get(AssetCategory.LifeInsurance),
        ],
        showList: false,
    },
};
export const initSelectedFilter = {
    simpleFilter: 0,
    assetFilter: 0,
    expiryMonth: 0,
    instrumentType: 0,
    optionType: 0,
    strikePrice: 0,
    underlyingAsset: 0,
};
export const initFilterTray = {
    simpleFilter: true,
    assetFilter: false,
    expiryMonth: false,
    instrumentType: false,
    optionType: false,
    strikePrice: false,
    underlyingAsset: false,
};
export var HoldingEdelweissAssetClass;
(function (HoldingEdelweissAssetClass) {
    HoldingEdelweissAssetClass["EQUITY"] = "Equity Related";
    HoldingEdelweissAssetClass["FI"] = "Fixed Income";
    HoldingEdelweissAssetClass["MP"] = "Managed Portfolios";
    // OTHERS = "Others",
    HoldingEdelweissAssetClass["ALL"] = "ALL";
    HoldingEdelweissAssetClass["RE"] = "Real Estate";
    HoldingEdelweissAssetClass["CO"] = "Commodities";
    HoldingEdelweissAssetClass["LI"] = "Life Insurance";
})(HoldingEdelweissAssetClass || (HoldingEdelweissAssetClass = {}));
export const findProductAssetType = (assetType) => {
    for (const tab in reportsTabAndDropDownData) {
        const dropDownList = reportsTabAndDropDownData[tab].assetProductList;
        for (const item of dropDownList) {
            if (Array.isArray(item.value)) {
                if (item.value.includes(assetType)) {
                    return { display: item.display, value: assetType };
                }
            }
            else {
                if (item.value === assetType) {
                    return item;
                }
            }
        }
    }
    return null;
};
export const holdingTabsAssetFilterValues = Object.values(reportsTabAndDropDownData)
    .map((value) => {
    var _a;
    if (value.assetName !== FilterTabEnum.DERIVATIVE)
        return (_a = value.assetProductList) === null || _a === void 0 ? void 0 : _a[0];
})
    .filter((x) => !!x);
export const tabWithAssetCategory = {
    [FilterTabEnum.ALL]: [],
    [FilterTabEnum.EQUITY]: [AssetCategory.Equity],
    [FilterTabEnum.FI]: [AssetCategory.FixedIncome],
    [FilterTabEnum.DERIVATIVE]: [AssetCategory.Derivatives],
    [FilterTabEnum.MP]: [AssetCategory.ManagedPortfolio],
    [FilterTabEnum.OTHERS]: [AssetCategory.RealEstate, AssetCategory.Commodity],
    [FilterTabEnum.INSURANCE]: [AssetCategory.LifeInsurance],
};
export const holdingAssetTabs = [
    {
        eventKey: FilterTabEnum.ALL,
        title: "All",
        id: FilterTabEnum.ALL,
    },
    {
        eventKey: FilterTabEnum.EQUITY,
        title: "Equity",
        id: FilterTabEnum.EQUITY,
    },
    {
        eventKey: FilterTabEnum.FI,
        title: "Fixed Income",
        id: FilterTabEnum.FI,
    },
    {
        eventKey: FilterTabEnum.MP,
        title: "Managed Portfolios",
        id: FilterTabEnum.MP,
    },
    {
        eventKey: FilterTabEnum.INSURANCE,
        title: "Life Insurance",
        id: FilterTabEnum.INSURANCE,
    },
    {
        eventKey: FilterTabEnum.OTHERS,
        title: "Others",
        id: FilterTabEnum.OTHERS,
    },
];
export const switchTabBasedOnDashboardRowClick = (assetCode) => {
    switch (assetCode) {
        case AssetCategory.ManagedPortfolio:
            return {
                tabkey: FilterTabEnum.MP,
                productOption: reportsTabAndDropDownData[FilterTabEnum.MP].assetProductList[0],
            };
        case AssetCategory.Equity:
            return {
                tabkey: FilterTabEnum.EQUITY,
                productOption: reportsTabAndDropDownData[FilterTabEnum.EQUITY].assetProductList[0],
            };
        case AssetCategory.Derivatives:
            return {
                tabkey: FilterTabEnum.DERIVATIVE,
                productOption: reportsTabAndDropDownData[FilterTabEnum.DERIVATIVE]
                    .assetProductList[0],
            };
        case AssetCategory.FixedIncome:
            return {
                tabkey: FilterTabEnum.FI,
                productOption: reportsTabAndDropDownData[FilterTabEnum.FI].assetProductList[0],
            };
        case AssetCategory.Commodity:
            return {
                tabkey: FilterTabEnum.OTHERS,
                productOption: reportsTabAndDropDownData[FilterTabEnum.OTHERS].assetProductList[2],
            };
        case AssetCategory.RealEstate:
            return {
                tabkey: FilterTabEnum.OTHERS,
                productOption: reportsTabAndDropDownData[FilterTabEnum.OTHERS].assetProductList[1],
            };
        case AssetCategory.LifeInsurance:
            return {
                tabkey: FilterTabEnum.INSURANCE,
                productOption: reportsTabAndDropDownData[FilterTabEnum.INSURANCE]
                    .assetProductList[0],
            };
        case AssetCategory.Total:
            return {
                tabkey: FilterTabEnum.ALL,
                productOption: null,
            };
        // default:
        //   props.setTabKey(FilterTabEnum.ALL);
        //   break;
    }
};
export const getRetainedAsset = (assetTab) => {
    try {
        let sessionAssetFilter = JSON.parse(sessionStorage.getItem("assetFilter"));
        if ((sessionAssetFilter === null || sessionAssetFilter === void 0 ? void 0 : sessionAssetFilter.length) > 0 && assetTab === FilterTabEnum.ALL)
            return sessionAssetFilter;
        return [];
    }
    catch (error) {
        //if failed to parse
        return [];
    }
};
export const pnlFilterAssetTabs = [
    {
        eventKey: IPNLSubTabs.EQUITY,
        title: FilterTabEnum.EQUITY,
        id: IPNLSubTabs.EQUITY,
        assetFilter: reportsTabAndDropDownData[FilterTabEnum.EQUITY],
        assestType: FilterTabEnum.EQUITY,
    },
    {
        eventKey: IPNLSubTabs.FIXED_INCOME,
        title: FilterTabEnum.FI,
        id: IPNLSubTabs.FIXED_INCOME,
        assetFilter: reportsTabAndDropDownData[FilterTabEnum.FI],
        assestType: FilterTabEnum.FI,
    },
    {
        eventKey: IPNLSubTabs.DERIVATIVE,
        title: FilterTabEnum.DERIVATIVE,
        id: IPNLSubTabs.DERIVATIVE,
        assetFilter: reportsTabAndDropDownData[FilterTabEnum.DERIVATIVE],
        assestType: FilterTabEnum.DERIVATIVE,
    },
    {
        eventKey: IPNLSubTabs.MANAGED_PORTFOLIO,
        title: FilterTabEnum.MP,
        id: IPNLSubTabs.MANAGED_PORTFOLIO,
        assetFilter: Object.assign(Object.assign({}, reportsTabAndDropDownData[FilterTabEnum.MP]), { assetProductList: reportsTabAndDropDownData[FilterTabEnum.MP].assetProductList.filter((y) => y.value !== AssetType.PMS && y.value !== AssetType.AIF) }),
        assestType: FilterTabEnum.MP,
    },
    {
        eventKey: IPNLSubTabs.OTHERS,
        title: "Others",
        id: IPNLSubTabs.OTHERS,
        assetFilter: reportsTabAndDropDownData[FilterTabEnum.OTHERS],
        assestType: FilterTabEnum.OTHERS,
    },
];
